exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._25qOLi9wdf5ui5fJAtZyr-{min-height:40px}", ""]);
// Exports
exports.locals = {
	"todo": "_25qOLi9wdf5ui5fJAtZyr-"
};